import React, { useEffect } from "react";
import Task, { taskTypes } from "components/Task";

const FolderEmptySummaryContent = () => {
  useEffect(() => {
    if (window.Application !== undefined) {
      window.Application.Dropzone.setupDropzone();
    }
  }, []);

  return (
    <div className="folder_empty_summary" data-testid="folder-empty-summary">
      <div className="folder_empty_summary__column1">
        <span className="folder_empty_summary__column1__title">
          {window.PageObject.docSetName}
        </span>
        <span className="folder_empty_summary__column1__description">
          Created {window.PageObject.creationDate} by{" "}
          {window.PageObject.username}
        </span>
        <div className="folder_empty_summary__column1__task_list">
          <Task
            type={taskTypes.uploadDocuments}
            args={{ docSetId: window.PageObject.docSetId }}
          />
        </div>
      </div>
    </div>
  );
};

export default FolderEmptySummaryContent;
